import { SportsEnum } from 'types/generated/client';
import CoachGrid from './CoachGrid';
import { CoachType } from './props';

interface InstantBookSectionProps {
  coaches: CoachType[];
  listHoveredCoachId: string | null;
  setListHoveredCoachId: (id: string | null) => void;
  activeSport: SportsEnum;
  vairProMap: Record<string, boolean>;
}

const InstantBookSection: React.FC<InstantBookSectionProps> = ({
  coaches,
  listHoveredCoachId,
  setListHoveredCoachId,
  activeSport,
  vairProMap,
}) => {
  if (coaches.length === 0) {
    return null;
  }

  return (
    <div className="mb-8">
      <h4 className="typography-product-subheading mb-ds-xl px-4 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary sm:px-8">
        Top coaches
      </h4>

      <CoachGrid
        coaches={coaches}
        listHoveredCoachId={listHoveredCoachId}
        setListHoveredCoachId={setListHoveredCoachId}
        activeSport={activeSport}
        vairProMap={vairProMap}
      />
    </div>
  );
};

export default InstantBookSection;
